import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  editPlateTitle: {
    id: 'editPlateTitle',
    defaultMessage: 'Edit plate'
  },
  editPlateBackButtonLabel: {
    id: 'editPlateBackButtonLabel',
    defaultMessage: 'Back to ordering'
  },
  plateNameRequired: {
    id: 'plateNameRequired',
    defaultMessage: 'Plate name is required.'
  },
  plateNameEditSuccess: {
    id: 'plateNameEditSuccess',
    defaultMessage: 'Plate name was edited successfully.'
  },
});

export default { ...generalMessages, ...messages };
